<template>
    <div class="label-value">
        <div class="label-value__label font-weight-thin">{{ label }}</div>
        <div :class="['label-value__value', 'font-weight-bold', emptyCssClass ]">
            {{ value || '-' }}
        </div>
    </div>
</template>
<script>

export default {
    name: 'LabelValue',
    props: [
        'label',
        'value',
    ],
    computed: {
        emptyCssClass() {
            return this.value && this.value.length ? '' : 'label-value__value-empty';
        },
    },
};

</script>
<style scoped lang="scss">
    .label-value__label {
        font-size: 14px;
    }
    .label-value__value {
        font-size: 20px;
    }
</style>
